// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing049({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/049/20250102_01.gif`}
      videoPath={`${process.env.REACT_APP_CDN_BASE}/images/049/20250102_02.mp4`}
      qOptionColor="blue"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/013/241118_07.png`}
      companyName="본원"
      apiUrl={apiUrl}
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing049;
